'use strict';

import {Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';

import {LocationService} from './location.service';
import {SmoothScrollUtil} from "../../../../../../nddUtils/smoothScrollUtil.service";
import {MediaQueries} from "../../../../../../infra/mediaQueries.service";
import {isBrowserIE} from "../../../../../../infra/browserSniffer";

@Component({
    'selector': 'prm-location-holdings',
    templateUrl: 'components/search/fullView/getit/opac/locations/location/locationHoldings.html',
})


export class PrmLocationHoldings {
    @Input() public currLoc;
    @Input() public serviceScrollId: string;
    private summaryLinesVisible: boolean = false;
    private isIe = isBrowserIE();

    constructor(private locationService: LocationService,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$element') private $element: ng.IAugmentedJQuery,
                private mediaQueries: MediaQueries) {
    }

    public viewMore(showMore, event) {
        this.summaryLinesVisible = showMore;
        event.stopPropagation();
        this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', '')
    }

    get isIE() {
        return this.isIe;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/location/locationHoldings.directive.ts